import React, { useState, useEffect } from "react";
import { GlobalSearchContext } from "./GlobalSearchContextInstance";

export const GlobalSearchProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const openSearch = (query?: string) => {
    if (query !== undefined) setSearchQuery(query);
    setIsOpen(true);
  };

  const closeSearch = () => {
    setIsOpen(false);
  };

  const toggleSearch = () => {
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        toggleSearch();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <GlobalSearchContext.Provider
      value={{
        isOpen,
        searchQuery,
        openSearch,
        closeSearch,
        toggleSearch,
        setSearchQuery,
      }}
    >
      {children}
    </GlobalSearchContext.Provider>
  );
};
